import { call, put, takeEvery } from "redux-saga/effects";
import {
  addSlideFail,
  addSlideSuccess,
  createBoardFail,
  createBoardSuccess,
  deleteBoardFail,
  deleteBoardSuccess,
  deleteSlideFail,
  deleteSlideSuccess,
  fetchBoardSlidesFail,
  fetchBoardSlidesSuccess,
  getBoardsListFail,
  getBoardsListSuccess,
  loginNoticeBoardFail,
  loginNoticeBoardSuccess,
  resetNoticeBoardPasswordFail,
  resetNoticeBoardPasswordSuccess,
  updateSlideFail,
  updateSlideSuccess,
} from "./actions";
import showToast from "common/Notification";
import {
  ADD_SLIDE,
  CHECK_BOARD_ACTIVITY,
  CREATE_BOARD,
  DELETE_BOARD,
  DELETE_SLIDE,
  FETCH_SLIDES,
  GET_BOARDS_LIST,
  LOGIN_TO_NOTICE_BOARD,
  RESET_NOTICE_BOARD_PASSWORD,
  UPDATE_SLIDE,
} from "./actionTypes";
import {
  onCreatingBoard,
  onGettingBoadsList,
  onGettingBoardSlides,
  onAddingSlide,
  onLoggingNoticeBoard,
  onDeletingSlide,
  onUpdatingSlide,
  onResetingBoardPassword,
  onCheckingBoardActivity,
  onDeletingBoard,
} from "helpers/fakebackend_helper";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Notice Board";

function* onResetBoardPassword({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onResetingBoardPassword, data);
    yield call(responseHandler, toastTitle, response, resetNoticeBoardPasswordSuccess, resetNoticeBoardPasswordFail, onSuccess, onError);
  } catch (err) {
    onError();
    console.log(err);
    yield put(resetNoticeBoardPasswordFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onDeleteBoard({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingBoard, data);
    yield call(responseHandler, toastTitle, response, deleteBoardSuccess, deleteBoardFail, onSuccess, onError);
  } catch (err) {
    onError();
    console.log(err);
    yield put(deleteBoardFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onCheckBoardActivity({ payload: { data, headers } }) {
  try {
    // only to check notice is active or not
    const response = yield call(onCheckingBoardActivity, data, headers);
  } catch (err) {
    console.log(err);
  }
}

function* onDeleteSlide({ payload: { data, syncList } }) {
  try {
    const response = yield call(onDeletingSlide, data);
    if (response.status) {
      yield put(deleteSlideSuccess(response));
      showToast("success", "Notice Board", response.message);

      syncList();
    } else {
      yield put(deleteSlideFail(response));
      showToast("warning", "Notice Board", response.message);
    }
  } catch (err) {
    console.log(err);
    yield put(deleteSlideFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onUpdateSlide({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingSlide, data);
    yield call(responseHandler, "Notice Board", response, updateSlideSuccess, updateSlideFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(updateSlideFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onLoginNoticeBoard({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onLoggingNoticeBoard, data);
    if (response.status) {
      localStorage.setItem(
        "auth",
        JSON.stringify({
          uid: response?.client_id,
          user_token: response?.user_token,
          ...response,
        })
      );
      showToast("success", "Notice Board", response.message);
      yield put(loginNoticeBoardSuccess(response));
      onSuccess(response);
    } else {
      onError(response);
      yield put(loginNoticeBoardFail(response));
      showToast("warning", "Notice Board", response.message);
    }
  } catch (err) {
    onError();
    console.log(err);
    yield put(loginNoticeBoardFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onCreateBoard({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onCreatingBoard, data);
    yield call(responseHandler, "Notice Board", response, createBoardSuccess, createBoardFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(createBoardFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onGetBoardsList({ payload: data }) {
  try {
    const response = yield call(onGettingBoadsList, data);
    if (response.status) {
      yield put(getBoardsListSuccess(response));
    } else {
      yield put(getBoardsListFail(response));
      showToast("warning", "Notice Board", response.message);
    }
  } catch (err) {
    console.log(err);
    yield put(getBoardsListFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* onGetBoardsSlides({ payload: { data, headers, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingBoardSlides, data, headers);
    yield call(responseHandler, "Notice Board", response, fetchBoardSlidesSuccess, fetchBoardSlidesFail, onSuccess, onError);
  } catch (err) {
    onError(err);
    yield put(fetchBoardSlidesFail(err));
  }
}

function* onAddSlide({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingSlide, data);
    yield call(responseHandler, "Notice Board", response, addSlideSuccess, addSlideFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(addSlideFail(err));
    showToast("error", "Notice Board", err);
  }
}

function* NoticeBoardSaga() {
  yield takeEvery(CREATE_BOARD, onCreateBoard);
  yield takeEvery(GET_BOARDS_LIST, onGetBoardsList);
  yield takeEvery(FETCH_SLIDES, onGetBoardsSlides);
  yield takeEvery(ADD_SLIDE, onAddSlide);
  yield takeEvery(LOGIN_TO_NOTICE_BOARD, onLoginNoticeBoard);
  yield takeEvery(UPDATE_SLIDE, onUpdateSlide);
  yield takeEvery(DELETE_SLIDE, onDeleteSlide);
  yield takeEvery(RESET_NOTICE_BOARD_PASSWORD, onResetBoardPassword);
  yield takeEvery(CHECK_BOARD_ACTIVITY, onCheckBoardActivity);
  yield takeEvery(DELETE_BOARD, onDeleteBoard);
}

export default NoticeBoardSaga;
